<template>
    <!-- banner-->
    <el-carousel :interval="5000*3" arrow="always"  height="700px" >
      <el-carousel-item>
          <video width="100%" height="100%" controls>
            <source src="images/c154779e3b9c6b7b612a8aa09c35c6bb.mp4" type="video/mp4">
            您的浏览器不支持 Video 标签。
          </video>
    </el-carousel-item>
    <el-carousel-item v-for="item in urls" :key="item"  >
      <el-image :src="item"  no-repeat style="object-fit: fill; height:100%; width:100%;"></el-image>
    </el-carousel-item>
  </el-carousel>
    <!-- //banner -->
</template>
<script>
  export default {
    data() {
      return {
        urls: [
          'images/skillsbg.jpg'
        ]
      }
    }
  }
</script>
